import { all, takeLatest, put, fork, call } from 'redux-saga/effects';
import actions from './actions';
import * as fillInTheBlanksServices from '@iso/services/listening/fillInTheBlanks';

//#region CRUD
export function* getFillInTheBlanks() {
	yield takeLatest(actions.GET_FILL_IN_THE_BLANKS, function* ({ payload }) {
		const { model } = payload;
		try {
			var response = yield call(fillInTheBlanksServices.getFillInTheBlanks, model);
			if (response.data.success === true) {
				var data = response.data.data.data;
				var totalItems = response.data.data.total;
				yield put({
					type: actions.GET_FILL_IN_THE_BLANKS_SUCCESS,
					payload: { data, totalItems },
				});
			}
		} catch (e) {
			yield put({
				type: actions.LISTENING_LOADING_FALSE,
			});
		}
	});
}

export function* getFillInTheBlanksDetail() {
	yield takeLatest(actions.GET_FILL_IN_THE_BLANKS_DETAIL, function* ({ payload }) {
		const { id } = payload;
		try {
			var response = yield call(fillInTheBlanksServices.getFillInTheBlanksDetail, id);
			if (response.data.success === true) {
				var data = response.data.data;
				yield put({
					type: actions.GET_FILL_IN_THE_BLANKS_DETAIL_SUCCESS,
					payload: { data },
				});
			}
		} catch (e) {
			yield put({
				type: actions.LISTENING_LOADING_FALSE,
			});
		}
	});
}

export function* createQuesFillInTheBlanks() {
	yield takeLatest(actions.CREATE_NEW_QUESTION_FILL_IN_THE_BLANKS, function* ({ payload, cbSuccess, cbError }) {
		const { body } = payload;
		try {
			var response = yield call(fillInTheBlanksServices.createQuesFillInTheBlanks, body);
			if (response.data.success === true) {
				yield cbSuccess();
			} else if (response?.data?.message === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			}
		} catch (e) {
				if (e?.response?.data?.ErrorMessage && e?.response?.data?.ErrorMessage === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			} else {
				yield cbError(e.response.data.ErrorMessage);
			};
		}
	});
}

export function* updateFillInTheBlanksDetail() {
	yield takeLatest(actions.UPDATE_FILL_IN_THE_BLANKS_DETAIL, function* ({ payload, cbSuccess, cbError }) {
		const { model } = payload;
		try {
			var response = yield call(fillInTheBlanksServices.updateFillInTheBlanksDetail, model);
			if (response.data.success === true) {
				yield cbSuccess();
			} else if (response?.data?.message === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			}
		} catch (e) {
				if (e?.response?.data?.ErrorMessage && e?.response?.data?.ErrorMessage === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			} else {
				yield cbError(e.response.data.ErrorMessage);
			};
		}
	});
}

export function* deleteFillInTheBlanks() {
	yield takeLatest(actions.DELETE_FILL_IN_THE_BLANKS, function* ({ payload, cbSuccess, cbError }) {
		const { id } = payload;
		try {
			var response = yield call(fillInTheBlanksServices.deleteFillInTheBlanks, id);
			if (response.data.success === true) {
				yield cbSuccess();
			}
		} catch (e) {
			if (e.response && e.response.data) yield cbError(e.response.data.ErrorMessage);
			else yield cbError();
		}
	});
}

export default function* rootSaga() {
	yield all([
		fork(getFillInTheBlanks),
		fork(getFillInTheBlanksDetail),
		fork(createQuesFillInTheBlanks),
		fork(updateFillInTheBlanksDetail),
		fork(deleteFillInTheBlanks),
	]);
}
